import moment from 'moment-timezone';

const shortDateFormat = 'MM/DD/YYYY';
const fullDateFormat = 'MM/DD/YYYY HH:mm';
const fullDateUsFormat = 'MM/DD/YYYY hh:mmA';
const dayTimeUSFormat = 'DD/MM hh:mm A';
const dayTimeFormat = 'DD/MM HH:mm';
const timeUsFormat = 'hh:mm A';

export default class DateFormatResolver {
	static resolve(date, format = fullDateFormat) {
		return moment(date).format(format) || ''
	}

	static resolveTimeFromSecs(timeInSeconds, format = 'mm:ss') {
		let result;
		const pad = function (num, size) { return ('000' + num).slice(size * -1); };
		const	time = parseFloat(timeInSeconds).toFixed(3);
		// eslint-disable-next-line no-unused-vars
		const	hours = Math.floor(time / 60 / 60);
		const	minutes = Math.floor(time / 60) % 60;
		const	seconds = Math.floor(time - minutes * 60);
		// eslint-disable-next-line no-unused-vars
		const	milliseconds = time.slice(-3);

		switch (format) {
			case 'mm:ss':
				result = minutes > 0
					? `${pad(minutes, 2)} m ${pad(seconds, 2)} s`
					: `${pad(seconds, 2)} s`;
				break;

			default:
				result = `${timeInSeconds} secs`
				break;
		}

		return result;
	}
}

export {
	shortDateFormat,
	fullDateFormat,
	fullDateUsFormat,
	dayTimeUSFormat,
	dayTimeFormat,
	timeUsFormat,
};
